<script setup>
import { computed, ref, onMounted, onBeforeMount, getCurrentInstance } from 'vue';

// CSS
import "./assets/css/all.min.css";
import "./assets/css/tailwind.css";

// Components
import HeaderMain from "./components/v2/header/HeaderMain.vue";
import FooterMain from "./components/v2/footer/FooterMain.vue";

const { proxy } = getCurrentInstance();
const maintenance = computed(
  () => proxy.$store.state.settings.maintenance === 'true');
const refreshed = ref(false);

const getMaintenance = () => {
  return proxy.$store.dispatch('fetchSettings')
}

const getMyInfo = async () => {
  await proxy.$store.dispatch('fetchRefreshToken')
  return proxy.$store.dispatch('fetchMyInfo')
}

// 생명주기 훅
onBeforeMount(() => {
  getMaintenance();
  setInterval(getMaintenance, 1000 * 30);

  getMyInfo().then(() => {
    refreshed.value = true;
  }).catch((error) => {
    refreshed.value =
      error.response?.status === 401 || error.response?.status === 500;
  });
  setInterval(getMyInfo, 1000 * 60);
});

onMounted(async () => {
  function loadScript(src) {
    return new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = src;
      script.async = true;
      script.onload = resolve;
      script.onerror = reject;
      document.body.appendChild(script);
    });
  }

  try {
    await loadScript("/assets/js/jquery-3.6.0.min.js");
    await loadScript("/assets/js/bootstrap.min.js");
    await loadScript("/plugins/wow/wow.min.js");
    await loadScript("/plugins/swiper/swiper-bundle.min.js");
    await loadScript("/plugins/odometer/appear.js");
    await loadScript("/plugins/fancybox/jquery.fancybox.min.js");
    await loadScript("/assets/js/theme.js");
    console.log("All third party scripts loaded");
  } catch (error) {
    console.error("Script loading failed:", error);
  }
});
</script>

<template>
  <div v-if="refreshed">
    <div v-if="!maintenance">
      <div v-if="$route.path == '/'">
        <HeaderMain />
        <router-view :key="$route.path" />
        <FooterMain />
      </div>
      <div v-else>
        <HeaderMain />
        <div class="page-content">
          <div class="route-content container">
            <router-view :key="$route.path" />
          </div>
        </div>
        <FooterMain />
      </div>
    </div>
    <div style="height: 100vh;" v-else>
      <div class="flex justify-center items-center w-full h-full" style="background: linear-gradient(rgb(0 0 0), rgb(7 15 15));">
        <img src="./assets/img/etc/maintain.jpg" alt="" style="width: 512px; height: 512px;"/>
      </div>
    </div>
  </div>
</template>

<style></style>
